import type { DateRange } from '@rio-cloud/rio-uikit/DayPicker';
import { useId } from 'react';

import { CustomDateRangePicker } from './CustomDateRangePicker.tsx';
import type { DatePeriod } from './datePeriod.ts';

export type DatePeriodFilterProps = {
    period: DatePeriod;
    setPeriod: (period: Exclude<DatePeriod, 'custom'>) => void;
    selectedDates?: DateRange;
    setCustomDatesRange: (value?: DateRange) => void;
    compact?: boolean;
};

export const DatePeriodFilter = ({
    period,
    setPeriod,
    selectedDates,
    setCustomDatesRange,
    compact = false,
}: DatePeriodFilterProps) => {
    const id = useId();

    return (
        <div className={compact ? 'width-200' : 'min-width-0'}>
            <CustomDateRangePicker
                id={`${id}-range`}
                period={period}
                setPeriod={setPeriod}
                value={selectedDates}
                onChange={setCustomDatesRange}
            />
        </div>
    );
};
